(() => {
  const placeholderSelector = '[data-inject-flashy-element="1803"]';
  const homepagePlaceholderSelector = '[data-inject-flashy-element="1799"]';
  const styleId = 'wholedent-flashy-review-layout';
  const ratingStyleId = 'wholedent-flashy-rating-count';
  const styles = `
    :host {
      display: block;
      max-width: 100%;
      container-type: inline-size;
    }

    article[dir] > header {
      gap: 12px;
      min-width: 0;
    }

    article[dir] > header > .w-2\\/3 {
      width: auto !important;
      flex: 0 1 auto;
      min-width: 0;
    }

    article[dir] > header > .relative.flex {
      gap: 16px;
      flex: 0 1 auto;
      min-width: 0;
    }

    article[dir] > header select.hide-on-mobile {
      width: 166px !important;
      min-width: 166px;
      max-width: 166px;
      flex: 0 0 166px;
    }

    article[dir] > header > .relative.flex > dialog {
      left: auto !important;
      right: 0 !important;
      width: 304px;
      max-width: min(304px, calc(100vw - 32px));
      margin-inline: 0 !important;
    }

    @container (max-width: 599px) {
      article[dir] > header {
        flex-wrap: wrap;
      }

      article[dir] > header > .w-2\\/3,
      article[dir] > header > .relative.flex {
        width: 100% !important;
        justify-content: space-between;
      }
    }
  `;
  const ratingStyles = `
    .review-rating-line > div.w-full {
      width: auto !important;
      flex: 1 1 0;
      min-width: 0;
    }

    .review-rating-line > span:last-child {
      flex: 0 0 auto;
      white-space: nowrap;
    }
  `;

  let observer;
  let ratingObserver;
  let ratingObserverRoot;

  function styleRatingCounts(root) {
    const ratingRoot = root.querySelector('dialog flashy-rating-reviews')?.shadowRoot;
    if (!ratingRoot) return false;
    if (ratingRoot.getElementById(ratingStyleId)) return true;

    const style = document.createElement('style');
    style.id = ratingStyleId;
    style.textContent = ratingStyles;
    ratingRoot.appendChild(style);
    return true;
  }

  function watchRatingCounts(root) {
    if (ratingObserverRoot !== root) {
      ratingObserver?.disconnect();
      ratingObserver = undefined;
      ratingObserverRoot = root;
    }
    if (styleRatingCounts(root)) {
      ratingObserver?.disconnect();
      ratingObserver = undefined;
      return;
    }

    ratingObserver ||= new MutationObserver(() => {
      if (styleRatingCounts(root)) {
        ratingObserver.disconnect();
        ratingObserver = undefined;
      }
    });
    ratingObserver.observe(root, { childList: true, subtree: true });
    customElements.whenDefined('flashy-rating-reviews').then(() => {
      if (ratingObserverRoot !== root) return;
      if (styleRatingCounts(root)) {
        ratingObserver?.disconnect();
        ratingObserver = undefined;
      }
    });
  }

  function applyLayout() {
    const productPlaceholder = document.querySelector(placeholderSelector);
    const placeholder = productPlaceholder || document.querySelector(homepagePlaceholderSelector);
    const widget = placeholder?.parentElement?.querySelector(
      productPlaceholder ? 'flashy-product-reviews' : 'flashy-customer-reviews'
    );
    const root = widget?.shadowRoot;
    if (!root) return false;
    if (productPlaceholder && !root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      root.appendChild(style);
    }
    watchRatingCounts(root);
    return true;
  }

  function watchForWidget() {
    if (applyLayout()) {
      observer?.disconnect();
      observer = undefined;
      return;
    }
    if (observer) return;

    observer = new MutationObserver(() => {
      if (applyLayout()) {
        observer.disconnect();
        observer = undefined;
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForWidget, { once: true });
  } else {
    watchForWidget();
  }
  document.addEventListener('shopify:section:load', watchForWidget);
})();
